export default __webpack_public_path__ + "static/hero420-f9540f083694e441b446fb31d506c91a.jpg";